import AppAPI from '../../api/app.js'

export const profile = {
    namespaced: true,

    actions: {
        reset(){},

        save( { commit, state, rootState } ){
            return new Promise( (resolve, reject) => {
                AppAPI.profile(rootState.app.user).then( response => {
                    commit( 'app/user', response.data, { root: true } )
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        }
    },

}